// src/supportColors.ts
export interface SupportColorSet {
  gradient: string
  glow: string
  hoverGlow: string
}

export const SUPPORT_COLORS = {
  meeting: {
    gradient: 'linear-gradient(135deg, #3A0CA3, #4361EE)',
    glow: 'rgba(67,97,238,0.25)',
    hoverGlow: 'rgba(67,97,238,0.40)',
  },
  knowledge: {
    gradient: 'linear-gradient(135deg, #E63946, #FF6B6B)',
    glow: 'rgba(255,107,107,0.25)',
    hoverGlow: 'rgba(255,107,107,0.40)',
  },
  contact: {
    gradient: 'linear-gradient(135deg, #FF8C00, #FFA500)',
    glow: 'rgba(255,165,0,0.25)',
    hoverGlow: 'rgba(255,165,0,0.40)',
  },
  whatsapp: {
    gradient: 'linear-gradient(135deg, #25D366, #128C7E)',
    glow: 'rgba(37,211,102,0.25)',
    hoverGlow: 'rgba(37,211,102,0.40)',
  },
  roadmap: {
    gradient: 'linear-gradient(135deg, #4F6EF7, #576CFF)',
    glow: 'rgba(79,110,247,0.25)',
    hoverGlow: 'rgba(79,110,247,0.40)',
  },
  bugs: {
    gradient: 'linear-gradient(135deg, #FF5F6D, #FF8E53)',
    glow: 'rgba(255,120,90,0.25)',
    hoverGlow: 'rgba(255,120,90,0.40)',
  },
  feature: {
    gradient: 'linear-gradient(135deg, #A05DEB, #F26FD4)',
    glow: 'rgba(162,82,220,0.25)',
    hoverGlow: 'rgba(162,82,220,0.40)',
  },
} as const

export type SupportColorKey = keyof typeof SUPPORT_COLORS
